'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M94.9 193.2l94.7 94.8-20.9 132.4 87.4-44.5 0-255.1-30.9 51.6-130.4 20.7z', 'M195.6 128.6l-201.1 32 143.9 144.1-31.7 201.2 197.5-100.5 0-458.1-108.6 181.4zm29.7 43.9l30.9-51.6 0 255.1-87.4 44.5 20.9-132.4-94.7-94.8 130.4-20.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;